import styled, { css } from 'styled-components';
import { mediaQuery } from 'common/theme/media';

export const Tablet = css``;
export const Styled = styled.div`
    img {
        width: 100%;
        border-radius: 8px;
    }

    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
`;
